import { AddVesselsSettingsDayTypeDialog } from "@/components/dialogs/AddVesselsSettingsDayTypeDialog";

export const VesselsSettingsDayTypesListingControls = () => {
	return (
		<div className="mb-4 flex flex-wrap items-start justify-between gap-x-4 gap-y-2">
			<AddVesselsSettingsDayTypeDialog />
		</div>
	);
};
